import {
  Required,
  Schema,
  TextField,
  RemoteDataSource
} from "lego-gui-lib/lib";
import { createContext } from "react";
import { mainStore, api } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { ForeignKeyField } from "lego-gui-lib";
import { Auth } from "../../core/model/auth";

export const LanguageSchema = new Schema({
  primaryKey: ["name"],
  security: {
    readableRole: Auth.Roles.ANY_ADMIN,
    editableRole: Auth.Roles.ADMIN
  },
  fields: [
    {
      name: "name",
      type: TextField(Required),
      title: t("common:name")
    }
  ]
});

mainStore.language = RemoteDataSource.create({
  api: api,
  name: "language",
  schema: LanguageSchema,
  url: "/languages",
  commons: mainStore.commons
});

export const languageContext = createContext(mainStore.language);

export const LanguageFK = ForeignKeyField(
  {
    dataSource: mainStore.language.listDataSource,
    labelField: "name",
    valueField: "name",
    minWidth: 70
  },
  Required
);
